import type { WebhookRegistration } from "../api";
import { WebhookDeleteDialog } from "./WebhookDeleteDialog";
import { WebhookRegistrationContent } from "./WebhookRegistrationContent";
import { useWebhookDeleteDialog } from "../hooks/useWebhookDeleteDialog";

interface WebhookRegistrationCardProps {
  registration: WebhookRegistration;
  onDelete: (registrationId: string) => void;
  isDeleting: boolean;
}

export function WebhookRegistrationCard({
  registration,
  onDelete,
  isDeleting,
}: WebhookRegistrationCardProps) {
  const { open, setOpen } = useWebhookDeleteDialog();

  const handleDelete = () => {
    if (registration.id) {
      onDelete(registration.id);
      setOpen(false);
    }
  };

  const deleteButton = registration.id ? (
    <WebhookDeleteDialog
      open={open}
      onOpenChange={setOpen}
      onDelete={handleDelete}
      isDeleting={isDeleting}
    />
  ) : null;

  return (
    <WebhookRegistrationContent
      registration={registration}
      onDeleteButton={deleteButton}
      webhookIdClassName="font-mono text-sm"
    />
  );
}
